import { LanguagesEnum } from '@/api/enums';
import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { Tag } from '@/client/tags';
import { PartialRequestMultiselect } from '@/components/form/generic/PartialRequestMultiselect';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type TagsMultiselectInputInputProps = {
  onChange: (value: Tag[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: Tag[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const TagsMultiselectInput: React.FC<TagsMultiselectInputInputProps> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const fetchTags = isDisabled
    ? undefined
    : async (params: ListingRequest) => await client.tags.getTags(params);

  return (
    <PartialRequestMultiselect
      dataKey="name"
      fetchService={fetchTags}
      customDataMap={(item: Tag) => ({
        ...item,
        name: item.translations?.find((t) => t.language === LanguagesEnum.EN)
          ?.name,
      })}
      customLabelMap={(item: Tag) =>
        item.translations?.find((t) => t.language === LanguagesEnum.EN)?.name
      }
      display="chip"
      optionLabel="name"
      optionValue="value"
      placeholder={t('generic.select')}
      maxSelectedLabels={1}
      additionalFilters={additionalFilters}
      selectedOptions={selectedOptions}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      isNotListingResponse
      filter={false}
    />
  );
};
